import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  makeStyles,
  Popper,
  Fade,
  Paper,
  Box
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  popper: {
    zIndex: 2000,
    transform: 'translateY(-1em)', // arrow height
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '0 100%'
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '100% 0'
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '100% 100%'
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '0 0'
      }
    }
  },
  popoverRoot: {
    background: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
    //maxWidth: '80%',
    width: props => props.field?.offsetWidth || 'auto'
  },
  arrow: {
    overflow: 'hidden',
    position: 'absolute',
    width: '1em',
    height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */,
    boxSizing: 'border-box',
    color: theme.palette.background.paper,

    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: '100%',
      height: '100%',
      boxShadow: theme.shadows[2],
      backgroundColor: 'currentColor',
      transform: 'rotate(45deg)'
    }
  },
  content: {
    padding: theme.spacing(2)
  }
}));

const ToolTip = props => {
  const { open, anchorElRef, arrow = true, children, placement = 'top' } = props;
  const [ arrowRef, setArrowRef ] = useState(null);
  const classes = useStyles({field: anchorElRef?.current, placement});

  return (
    <Popper
      open={open}
      anchorEl={anchorElRef?.current}
      placement={placement}
      transition
      className={classes.popper}
      modifiers={{
        flip: {
          enabled: false
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: 'window'
        },
        arrow: {
          enabled: arrow,
          element: arrowRef
        },
        computeStyle: {gpuAcceleration: false}
      }}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Paper className={classes.popoverRoot}>
            {arrow ? (
              <span className={classes.arrow} ref={setArrowRef} />
            ) : null}
            <Box className={classes.content}>{children}</Box>
          </Paper>
        </Fade>
      )}
    </Popper>
  )
};

//<ClickAwayListener onClickAway={onClose}>

ToolTip.propTypes = {
  open: PropTypes.bool,
  anchorElRef: PropTypes.any,
  arrow: PropTypes.bool,
  children: PropTypes.node,
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
}

export default ToolTip;
